import { createFileRoute } from '@tanstack/react-router'
import SettlementsReportList from 'Royalty/components/Test/tabs/SettlementsReportList'

export const Route = createFileRoute('/royalty/reports/settlements')({
    component: SettlementsReportList,
})
